<h3 mat-dialog-title>{{ 'DISCARD_CHANGES' | translate }}</h3>
<mat-dialog-content>
  <p>
    {{ 'UNSAVED_CHANGES_WARNING' | translate }}
  </p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>{{ 'STAY_ON_PAGE' | translate }}</button>
  <button mat-button [mat-dialog-close]="true" cdkFocusInitial>
    {{ 'DISCARD_AND_LEAVE' | translate }}
  </button>
</mat-dialog-actions>